import React from "react";
import PropTypes from "prop-types";
import ArticleCard from "./ArticleCard";
import { Container } from "react-bootstrap";
import { graphql } from "gatsby";
import Moment from "moment";
import { StarFill } from "react-bootstrap-icons";

import "../styles/components/FeaturedBlogPost.scss";

const FeaturedBlogPost = ({ blogPost }) => {
    if (!blogPost) return null;

    const blogPrefix =
        blogPost.type === "B2B Blog Post"
            ? "/insights/knowledge-center"
            : "/professionals/blog";

    return (
        <div className="featured-blog-post">
            <Container>
                <div className="featured-icon mb-3">
                    <div className="icon me-2">
                        <StarFill color="white" size={16} />
                    </div>
                    <span>FEATURED</span>
                </div>

                <ArticleCard post={blogPost} featured urlPrefix={blogPrefix} />
            </Container>
        </div>
    );
};

export const query = graphql`
    fragment DynamicFeaturedBlogPost on ContentfulFeaturedBlogPost {
        sys {
            contentType {
                sys {
                    id
                }
            }
        }
        takesFullPageWidth
        blogPost {
            title
            slug
            image {
                gatsbyImageData(layout: CONSTRAINED)
                title
                description
                file {
                    contentType
                    url
                }
            }
            body {
                raw
            }
            topics {
                slug
                name
            }
            publishDate
            type
        }
    }
`;

FeaturedBlogPost.propTypes = {
    blogPostType: PropTypes.string.isRequired,
    blogPost: PropTypes.shape({
        title: PropTypes.string,
        slug: PropTypes.string,
        publishDate: PropTypes.instanceOf(Moment),
        image: PropTypes.shape({
            title: PropTypes.string,
            description: PropTypes.string,
            gatsbyImageData: PropTypes.object,
            file: PropTypes.shape({ url: PropTypes.string }),
        }),
        topics: PropTypes.arrayOf(
            PropTypes.shape({
                slug: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
        ),
        body: PropTypes.shape({ raw: PropTypes.string.isRequired }),
    }),
};

export default FeaturedBlogPost;
